import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import HeadingComponent from "../../../../component/atom/Headings/Heading";
import TableComponent from "../../../../component/atom/Table/TableComponent";
import TextButtonComponet from "../../../../component/atom/Buttons/TextButton";
import { connect } from "react-redux";
import { Actions } from "../../../../core/modules/Actions";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import {
  DialogComponent,
  IconButtonComponent,
  PaginationTable,
  TextIconButtonComponent,
} from "../../../../component/atom";
import { PopUpMessageComponent } from "../../../../component/molecule";
import { AdminGraphView, ResetQuizAttemptsForm } from "../../../../component/molecule/Forms";
import { faDownload, faRotateLeft } from "@fortawesome/free-solid-svg-icons";

const AdminSubmissionHistoryScreen = ({
  quizSubmissionHistory,
  getQuizSumbissionHistory,
  getAllQuizSumbissionHistory,
  deleteAttempt,
  graphData,
  onGetAttemptgraph,
  quizAllSubmissionHistory,
  resetAttempts = () => { },
  downloadQuizScoresCSV
}) => {
  const [list, setList] = useState([]);
  const navigate = useNavigate();
  const [userId, setUserId] = useState(0);
  const [quizId, setQuizId] = useState(0);
  const [attempt, setAttempt] = useState(0);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [open,setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [allList, setAllList] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [openResetDialog, setOpenResetDialog] = useState(false);
  const [currentFilters, setCurrentFilters] = useState({});

  // Helper function to clean filter values (remove query strings, trim, etc.)
  const cleanFilterValue = (value) => {
    if (!value) return value;
    // Remove any query string fragments like ?v=1
    let cleaned = String(value).split('?')[0].trim();
    // Remove any URL-encoded characters that shouldn't be there
    cleaned = cleaned.replace(/%3F.*$/, ''); // Remove %3F (encoded ?) and everything after
    return cleaned;
  };

  const buildFilterParams = (filters) => {
    const filterParams = {};
    
    // Map filter values to API parameters
    // MUIDataTable filters are arrays, take the first value and clean it
    if (filters.quiz_name && filters.quiz_name.length > 0) {
      const cleanedName = cleanFilterValue(filters.quiz_name[0]);
      // Find quiz_id from the list based on quiz_name
      const quizItem = list.find(item => item.quiz_name === cleanedName);
      if (quizItem && quizItem.quiz_id) {
        filterParams.quiz_id = quizItem.quiz_id;
      }
    }
    if (filters.user_id && filters.user_id.length > 0) {
      filterParams.user_id = cleanFilterValue(filters.user_id[0]);
    }
    if (filters.user_name && filters.user_name.length > 0) {
      filterParams.user_name = cleanFilterValue(filters.user_name[0]);
    }
    if (filters.email && filters.email.length > 0) {
      filterParams.email = cleanFilterValue(filters.email[0]);
    }
    if (filters.attempts && filters.attempts.length > 0) {
      filterParams.attempts = cleanFilterValue(filters.attempts[0]);
    }
    if (filters.finished_at && filters.finished_at.length > 0) {
      const dateValue = cleanFilterValue(filters.finished_at[0]);
      // Convert date to YYYY-MM-DD format for backend (same as download CSV)
      try {
        // Try parsing the date value - it might be in DD-MM-YYYY format (as displayed in table)
        // or already in YYYY-MM-DD format
        let parsedDate = moment(dateValue, "DD-MM-YYYY", true); // strict parsing with DD-MM-YYYY
        if (!parsedDate.isValid()) {
          // Try parsing as YYYY-MM-DD format
          parsedDate = moment(dateValue, "YYYY-MM-DD", true);
        }
        if (!parsedDate.isValid()) {
          // Try parsing without format (moment's default parsing)
          parsedDate = moment(dateValue);
        }
        
        if (parsedDate.isValid()) {
          filterParams.finished_at = parsedDate.format("YYYY-MM-DD");
        } else {
          // If parsing fails, use the cleaned value as-is
          filterParams.finished_at = dateValue;
        }
      } catch (e) {
        // If moment parsing fails, use the cleaned value as-is
        filterParams.finished_at = dateValue;
      }
    }
    
    return filterParams;
  };

  const fetchQuizSubmissionHistory = (page, perPage, search, filters = {}) => {
    const trimmedSearch = search ? search.trim() : ""; 
    const filterParams = buildFilterParams(filters);
    
    getQuizSumbissionHistory({ 
      page, 
      per_page: perPage, 
      search: trimmedSearch,
      ...filterParams
    });
  };

  useEffect(() => {
    fetchQuizSubmissionHistory(currentPage, rowsPerPage, searchQuery, currentFilters);
  }, [currentPage, rowsPerPage, searchQuery, currentFilters]);

  useEffect(() => {
    if (quizSubmissionHistory) {
      setList(quizSubmissionHistory.data);
      setTotalPages(quizSubmissionHistory.last_page);
      setRowsPerPage(quizSubmissionHistory.per_page);
      setTotalItems(quizSubmissionHistory.total);
    }
  }, [quizSubmissionHistory, currentPage]);



  const columns = [
    {
      name: "quiz_name",
      label: "Quiz",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "user_id",
      label: "",
      options: {
        filter: true,
        sort: false,
        display: false,
      },
    },
    {
      name: "user_name",
      label: "Student Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "email",
      label: "Email",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "attempts",
      label: "Attempt",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "finished_at",
      label: "Submitted Date",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return moment(value).format("DD-MM-YYYY");
        },
      },
    },

    {
      name: "id",
      label: "View Assessment",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const matchingItem = list?.find(item => item?.id === value);
          const attempt = matchingItem?.attempts || 0;
   
          return (
            <Box sx={{ width: "fit-content" }}>
              <TextButtonComponet
                text={"Assessment Form "}
                onButtonClick={() =>
                  navigate(
                    `/admin-quiz-assessment/${value}/${tableMeta.rowData[0]}`,
                    {
                      state: {
                        quiz_status_id: value,
                        user_id: tableMeta.rowData[1],
                        quiz_name: tableMeta.rowData[0],
                        stuName: tableMeta.rowData[2],
                        quiz_id: tableMeta.rowData[7],
                        attempt: attempt
                      },
                    }
                  )
                }
              />
            </Box>
          );
        },
      },
    },
    // {
    //   name: "id",
    //   label: "View Graph",
    //   options: {
    //     filter: true,
    //     sort: false,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return (
    //         <Box sx={{ width: "fit-content" }}>
    //         <TextButtonComponet
    //           text={"View Graph"}
    //           disabled={tableMeta.rowData[5] == 0 ? true : false}
    //           onButtonClick={() => onViewBtn(tableMeta, value)}/>
    //         </Box>
    //       );
    //     },
    //   },
    // },
    {
      name: "quiz_id",
      label: "Quize Id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "id",
      label: "Reset Attempts",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <IconButtonComponent
              btnType={"deleteIconbtn"}
              onclick={() => {
                onPressDeletebtn(tableMeta, value);
                setConfirmDelete(true);
              }}
            />
          );
        },
      },
    },
  ];

  const onPressDeletebtn = (tableMeta, value) => {
    list?.forEach((item) => {
      if (value == item?.id) {
     
        setAttempt(item?.attempts);
        setQuizId(item?.quiz_id);
        setUserId(item?.user_id);
      }
    });
  };

  const ondeleteAttempt = async () => {
    try {
      await deleteAttempt({
        user_id: userId,
        quiz_id: quizId,
        attempt: attempt,
      });
      // Refresh list
      fetchQuizSubmissionHistory(currentPage, rowsPerPage, searchQuery, currentFilters);
    } catch (error) {
      console.error("Failed to delete attempt:", error);
    } finally {
      setConfirmDelete(false);
    }
  };

  useEffect(() => {
    setAllList(quizAllSubmissionHistory.data || []);
  }, [quizAllSubmissionHistory])

  const handleDownloadAll = async () => {
    try {
      const recordCount = totalItems;
      await  getAllQuizSumbissionHistory({ 
        page:1, 
        per_page: recordCount, 
        search: '' });
        
      return allList;
     
    } catch (error) {
      return [];
    }
  };

  const handleFilterChange = (filters) => {
    setCurrentFilters(filters);
    // Reset to first page when filters change
    setCurrentPage(1);
  };

  const handleDownloadCSV = async () => {
    setIsDownloading(true);
    try {
      // Build filter parameters from current filters
      const filterParams = buildFilterParams(currentFilters);

      // Add search query if present
      if (searchQuery && searchQuery.trim()) {
        filterParams.search = cleanFilterValue(searchQuery.trim());
      }

      await downloadQuizScoresCSV(filterParams);
    } catch (error) {
      console.error("Failed to download CSV:", error);
      // Error handling is done in the Handler
    } finally {
      setIsDownloading(false);
    }
  };

  const handleOpenResetDialog = () => setOpenResetDialog(true);

  const handleCloseResetDialog = () => setOpenResetDialog(false);

  return (
    <>
      <Box className="main-screen-container">
        <Grid container flexDirection={"column"} spacing={3}>
          <Grid item>
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
              <Grid item>
                <HeadingComponent
                  text={"Submission History"}
                  fontweigth={600}
                  size={40}
                  fontfamily={"Montserrat"}
                  backNavigation={true}
                />
              </Grid>
              <Grid item>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <TextIconButtonComponent
                    buttonStyleClass="btn btn-primary"
                    btnText={"Download CSV"}
                    icon={faDownload}
                    onclick={handleDownloadCSV}
                    loading={isDownloading}
                  />
                  <TextIconButtonComponent
                    buttonStyleClass="btn btn-primary"
                    btnText={"Reset Quiz Attempts"}
                    icon={faRotateLeft}
                    onclick={handleOpenResetDialog}
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid item xs={2}>
            <TextButtonComponet
              onButtonClick={() => navigate(-1)}
              text={"Back"}
              classStyle="btn btn-secondary"
            />
          </Grid> */}
          <Grid item>
          <PaginationTable
            columns={columns}
            data={list}
            totalRecords={totalPages}
            currentPage={currentPage}
            rowsPerPage={rowsPerPage}
            totalItems={totalItems}
            onPageChange={(page) => setCurrentPage(page)}
            onRowsPerPageChange={(perPage) => setRowsPerPage(perPage)}
            onSearchChange={(searchText) => {
              setSearchQuery(searchText);
            }}
            onFilterChange={handleFilterChange}
            onDownloadData={handleDownloadAll}
            name={'submissions'}
            hideDownloadButton={true}
            currentFilters={currentFilters}
          />
          </Grid>
        </Grid>
      </Box>

      <PopUpMessageComponent
        open={confirmDelete}
        type={"other"}
        title={"Delete!"}
        message={"Are you sure you want delete Attempt?"}
        btntext={"Yes, delete"}
        altbtntext={"No"}
        onclick={ondeleteAttempt}
        altonclick={() => setConfirmDelete(false)}
        onclose={() => setConfirmDelete(false)}
      />
      <DialogComponent
        title={"Reset Quiz Attempts"}
        open={openResetDialog}
        onClose={handleCloseResetDialog}
      >
        <ResetQuizAttemptsForm
          onclickcancel={handleCloseResetDialog}
          onSuccess={() => {
            fetchQuizSubmissionHistory(currentPage, rowsPerPage, searchQuery, currentFilters);
            handleCloseResetDialog();
          }}
        />
      </DialogComponent>
         <DialogComponent
        isShowCloseButton={true}
        title={"View Graph"}
        open={open}
        onClose={() => setOpen(false)}
      >
        <AdminGraphView   graphData={graphData} onClose={() => setOpen(false)} />
      </DialogComponent>
    </>
  );
};

export default connect(
  (state) => ({
    quizSubmissionHistory: state.quizes.get("quizSubmissionHistory"),
    graphData:state.quizes.get("graphData"),
    quizAllSubmissionHistory:state.quizes.get("quizAllSubmissionHistory"),
  }),
  {
    getQuizSumbissionHistory: Actions.quizes.getQuizSumbissionHistory,
    deleteAttempt: Actions.quizes.deleteAttempt,
    resetAttempts: Actions.quizes.resetAttempts,
    onGetAttemptgraph:Actions.quizes.onGetAttemptgraph,
    getAllQuizSumbissionHistory: Actions.quizes.getAllQuizSumbissionHistory,
    downloadQuizScoresCSV: Actions.quizes.downloadQuizScoresCSV,
  }
)(AdminSubmissionHistoryScreen);
